/* !
 * stores.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const $path = location.pathname;
	const $Param = location.search;
	let paramList = [];
	if($Param) { paramList = $Param.replace(/\?/, '').split('&'); };
	console.log('paramList',paramList)

	// JSON取得 ===============================================
	// 県取得
	const getJSONPrefList = () => {
		return `/ajax/tenpo/area_list.json`;
	}
	// 英語　エリア一覧
	const getJSONshopListsAreaEn = () => {
		return `/ajax/en/tenpo/area_list.json`;
	}
	 

	// ============ ↓↓ FUNCTIONS ↓↓ =＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	// 県セレクト作成
	const createPrefSelect = () => {
		const prefSelect = document.querySelector('.js-pref-select');
		if (!prefSelect) return;
		fetch(getJSONPrefList())
			.then(response => response.json())
			.then(data => {
				data.rt_bn_tenpo_area_list.forEach(pref => {
					const option = document.createElement('option');
					option.value = pref._key;
					option.textContent = $path.includes('/ja/') ? pref.cf_ta_name_jp : pref.cf_ta_name_en;
					// URLパラメータと一致する場合はselected属性を付与
					paramList.forEach(param => {
						const [key, value] = param.split('=');
						if(key === 'p_area' && value === option.value) {
							option.selected = true;
						}
					});
					prefSelect.appendChild(option);
				});
			})
			.catch(error => {
				console.error('Error fetching JSON:', error);
			});
	}
	// チェックボックス
	const setCheckboxes = () => {
		const checkboxes = document.querySelectorAll('input[type="checkbox"]');
		if(!checkboxes.length) return;
		checkboxes.forEach(checkbox => {
			const checkboxName = checkbox.name;
			paramList.forEach(param => {
				const [key, value] = param.split('=');
				if(key === checkboxName && value === checkbox.value) {
					checkbox.checked = true;
				}
			});
		});
	};

	// 【英】国セレクト
	const createCountrySelectEn = () => {
		const countrySelect = document.querySelector('.js-country-select');
		const regionSelect = document.querySelector('.js-region-select');
		if (!countrySelect) return;
		fetch(getJSONshopListsAreaEn())
			.then(response => response.json())
			.then(data => {
				const addedKeys = new Set();
				data.rt_bn_tenpo_area_list.forEach(country => {
					const key = country.cf_ta_group_master._key;
					if (!addedKeys.has(key)) {
						const option = document.createElement('option');
						option.value = key;
						option.textContent = country.cf_ta_country_name_en;
						// URLパラメータと一致する場合はselected属性を付与
						paramList.forEach(param => {
							const [paramKey, value] = param.split('=');
							if (paramKey === 'p_country' && value === option.value) {
								option.selected = true;
							}
						});
						countrySelect.appendChild(option);
						addedKeys.add(key);
					}
				});

				// countrySelectチェンジ時にregionSelectを更新
				const updateRegionSelect = (selectedKey) => {
					if (!regionSelect) return;
					regionSelect.innerHTML = '<option value="">Region</option>'; // 既存optionクリア
					data.rt_bn_tenpo_area_list.forEach(country => {
						const groupKey = country.cf_ta_group_master._key;
						if (groupKey === selectedKey) {
							const regionOption = document.createElement('option');
							regionOption.value = country._key;
							regionOption.textContent = country.cf_ta_name_en;
							// p_areaパラメータと一致する場合は選択状態にする
							paramList.forEach(param => {
								const [key, value] = param.split('=');
								if (key === 'p_area' && value === regionOption.value) {
									regionOption.selected = true;
								}
							});
							regionSelect.appendChild(regionOption);
						}
					});
				};

				countrySelect.addEventListener('change', () => {
					updateRegionSelect(countrySelect.value);
				});

				// パラメータにp_countryがあればregionSelectを反映
				const pCountryParam = paramList.find(param => param.startsWith('p_country='));
				if (pCountryParam) {
					const pCountryValue = pCountryParam.split('=')[1];
					if (pCountryValue) {
						countrySelect.value = pCountryValue;
						updateRegionSelect(pCountryValue);
					}
				}
			})
			.catch(error => {
				console.error('Error fetching JSON:', error);
			});
	}

	const keywordSearch = () => {
		const keywordBtn = document.querySelector('.js-keyword-submit');
		if (!keywordBtn) return;
		keywordBtn.addEventListener('click', () => {
			const form = document.querySelector('form.stores-top-column-left-inner');
			if (form) {
				form.submit();
			}
		});
	}

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const storesFUNCTIONS = () => {
		createPrefSelect();
		setCheckboxes();
		createCountrySelectEn();
		keywordSearch();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { storesFUNCTIONS(); }) : storesFUNCTIONS();

})(window.FUNCTIONS);
